import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Complexes/Create';

const { displayName } = config;

function ComplexCreate(): React.JSX.Element {
  document.title = `${displayName}: Добавить комплекс`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default ComplexCreate;
